const loadScript = (url: string, callback?: () => void) => {
  const script = document.createElement('script');
  if (callback) script.addEventListener('load', callback);
  script.src = url;
  document.body.appendChild(script);
};

enum SCRIPT_URL {
  ALUCARD = '/assets/interview/library/Alucard.min.js',
  D3 = '/assets/interview/library/d3.min.js',
}

export const loadAlucard = (onload: () => void, useD3 = false) => {
  loadScript(SCRIPT_URL.ALUCARD, onload);
  if (useD3) loadScript(SCRIPT_URL.D3);
};
